import * as React from "react";
import { useGetAllBusinessVerticalsQuery } from "../services/vertical.service";
import SelectBase, { SelectOption } from "./global/SelectBase";

const SelectVerticals = ({
  onChange,
  values,
}: {
  onChange: (ids?: number[]) => void;
  values: number[];
}) => {
  const {
    data: verticals,
    isLoading,
  } = useGetAllBusinessVerticalsQuery({
    sortField: "name",
    sortMode: "asc",
  });

  const options = React.useMemo<SelectOption[]>(() => {
    return (verticals || []).map((vertical) => ({
      label: vertical.name,
      value: vertical.id,
    }));
  }, [verticals]);

  const selected = React.useMemo<SelectOption[]>(() => {
    if (!values || !verticals) return [];
    return verticals
      .filter((it) => values.includes(it.id))
      .map((vertical) => ({
        label: vertical.name,
        value: vertical.id,
      }));
  }, [verticals, values]);

  return (
    <SelectBase
      options={options}
      value={selected}
      onChange={(newValue) => {
        const options = (newValue as SelectOption[]) || [];
        onChange(options.map((opt) => opt.value as number));
      }}
      label="Industries"
      placeholder="Search..."
      isMulti={true}
      isLoading={isLoading}
    />
  );
};
export default SelectVerticals;
